import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { CustomizedSportsState } from 'src/AppState/CmsState/SportsState/SportsState';
import { ExistingSportsForm } from './ExistingSportsForm';
import { NewSportsForm } from './NewSportsForm';
import { TabItemSecondary, TabsWrapperSecondary } from 'src/domains/layouts/shared/tabs/Tabs.style';
import { FormWrapper } from 'src/domains/layouts/shared/cms/form/Form.style';

interface PropsTypes {
    sportState: CustomizedSportsState;
}

export const SportsForm = observer('SportsForm', ({ sportState }: PropsTypes) => {
    const { sportConfigType, handleSportConfigType, isEditMode, resetForm } = sportState;

    return (
        <FormWrapper>
            <FormHeader
                isEditMode={isEditMode}
                defaultLabel='Customize sport'
                editModeLabel='Edit sport'
                resetForm={resetForm}
            />

            <TabsWrapperSecondary>
                <TabItemSecondary
                    disabled={isEditMode}
                    isActive={sportConfigType === 'existing-sport'}
                    onClick={(): void => handleSportConfigType('existing-sport')}
                    data-test='customize-existing-sport'
                >
                    Customize existing sport
                </TabItemSecondary>
                <TabItemSecondary
                    disabled={isEditMode}
                    isActive={sportConfigType === 'new-sport'}
                    onClick={(): void => handleSportConfigType('new-sport')}
                    data-test='customize-new-sport'
                >
                    Customize new sport
                </TabItemSecondary>
            </TabsWrapperSecondary>

            {sportConfigType === 'existing-sport' ? (
                <ExistingSportsForm sportState={sportState} />
            ) : (
                <NewSportsForm sportState={sportState} />
            )}
        </FormWrapper>
    );
});
